import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { ContactFormGroup } from '@app/models/form.models';

function syncPasswordMismatch(group: AbstractControl) {
  const p = group.get('password')?.value ?? '';
  const c = group.get('confirmPassword')?.value ?? '';
  const confirm = group.get('confirmPassword');
  if (!confirm) return null;

  if (p && c && p !== c) {
    confirm.setErrors({ ...(confirm.errors ?? {}), mismatch: true });
  } else if (confirm?.errors?.['mismatch']) {
    const { mismatch, ...rest } = confirm.errors;
    confirm.setErrors(Object.keys(rest).length ? rest : null);
  }
  return null;
}

export function buildContactForm(fb: FormBuilder): ContactFormGroup {
  return fb.group(
    {
      email: fb.nonNullable.control('', [
        Validators.required,
        Validators.email,
      ]),
      password: fb.nonNullable.control('', [
        Validators.required,
        Validators.minLength(6),
      ]),
      confirmPassword: fb.nonNullable.control('', [Validators.required]),
      titleCode: fb.nonNullable.control(''),
      firstName: fb.nonNullable.control('', [Validators.required]),
      middleName: fb.nonNullable.control(''),
      lastName: fb.nonNullable.control('', [Validators.required]),
      phoneNumber: fb.nonNullable.control(''),
    },
    { validators: [syncPasswordMismatch] }
  );
}
